import getRuntimeEnv from 'helpers/getRuntimeEnv';

export const DIGITAL_EXCHANGE_DOMAIN = '/digital-exchange';

// Resolves the domain used for the component-manager API. When the
// COMPONENT_MANAGER_URL env variable is set (absolute URL or path) it is used
// as-is; otherwise it falls back to the `/digital-exchange` path on the DOMAIN host.
const getComponentManagerDomain = () => (
  getRuntimeEnv().COMPONENT_MANAGER_URL || DIGITAL_EXCHANGE_DOMAIN
);

export default getComponentManagerDomain;
